import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { clearOnInvitation } from "../../../actions/dispatch/dispatchCommon";
import { COMMON_STATUS, PAGE_FLOW } from "../../../constants/status";
import { IInvitation } from "../../../interface/IAccount";

import { getTenantInfo } from "../../../reducers/tenant";

import { Message } from "primereact/message";
import { useForm, Controller } from "react-hook-form";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import { Password } from "primereact/password";
import { Divider } from "primereact/divider";
import { classNames } from "primereact/utils";
import "./Invitation.scss";
import { getTenantName } from "../../../reducers/app";
import { getInvitiation, invitationAsync } from "../../../reducers/invitation";
import {
  getLoginStatus,
  getToken,
  invitationSendAsync,
  updateLoginStatus,
} from "../../../reducers/login";
import history from "../../../helper/history";
import { Loading } from "../../Loading/Loading";
import _ from "underscore";

type Props = {
  setToken: any;
};

const Invitation: React.FC<Props> = (props: Props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const client_info = useSelector(getTenantInfo);
  const [showMessage, setShowMessage] = useState(false);
  const tenant_name = useSelector(getTenantName);
  const invitation_store = useSelector(getInvitiation);
  const login_status_store = useSelector(getLoginStatus);
  const login_token_store = useSelector(getToken);
  const [formData, setFormData] = useState({});
  const [pageFlow, setPageFlow] = useState<string>(PAGE_FLOW.START);
  const [invitationDetail, setInvitationDetail] = useState<IInvitation | null>(
    null
  );
  const defaultValues = {
    confirmPassword: "",
    contactMail: "",
    expired: false,
    guid: "",
    missing: false,
    newPassword: "",
    token: "",
  };
  const [show_loader, setShowLoader] = useState(true);
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    watch,
  } = useForm({ defaultValues, shouldFocusError: false });
  const newPassword = watch("newPassword", "");
  const onSubmit = (data: any) => {
    setFormData(data);
    setShowMessage(true);

    const model = {
      tenantName: tenant_name || null,
      model: {
        contactMail: invitationDetail?.contactMail,
        guid: invitationDetail?.guid,
        newPassword: data.newPassword,
        confirmPassword: data.confirmPassword,
        expired: invitationDetail?.expired,
        missing: invitationDetail?.missing,
        token: invitationDetail?.token,
      },
    };

    dispatch(invitationSendAsync(model));
    setShowLoader(true);
  };

  useEffect(() => {
    sessionStorage.setItem('page', 'invitation');
},[]);

  useEffect(() => {
    if (pageFlow === PAGE_FLOW.START) {
      clearOnInvitation(dispatch);
      setPageFlow(PAGE_FLOW.INITIAL);
    }
  }, [dispatch, pageFlow]);

  useEffect(() => {
    if (pageFlow === PAGE_FLOW.INITIAL) {
      let searchUrl = window.location.search;
      if (searchUrl) {
        searchUrl = searchUrl.replace("?", "");
        const searchParams = searchUrl.split("&");
        searchParams.map((searchParam) => {
          const sp = searchParam.split("=");
          if (sp[0] === "id") {
            const params = {
              id: sp[1],
              tenantName: tenant_name,
            };

            dispatch(invitationAsync(params));
          }
        });

        setPageFlow(PAGE_FLOW.DONE);
      }
    }
  }, [defaultValues, dispatch, pageFlow, tenant_name]);

  useEffect(() => {
    if (
      invitation_store.status === COMMON_STATUS.LOADED &&
      pageFlow === PAGE_FLOW.DONE
    ) {
      setInvitationDetail(invitation_store.value);
      setPageFlow(PAGE_FLOW.COMPLETE);
      setShowLoader(false);
    }
  }, [invitation_store.status, invitation_store.value, pageFlow]);

  useEffect(() => {
    if (login_status_store === COMMON_STATUS.AUNTHETICATED) {
      props.setToken(login_token_store);
      dispatch(updateLoginStatus(COMMON_STATUS.LOGIN));
      history.push(`${process.env.PUBLIC_URL}/${tenant_name}`);
    }
  }, [dispatch, login_status_store, login_token_store, props, tenant_name]);

  const missingContent = () => {
    return (
      <>
        <i className="pi pi-exclamation-triangle pr-2 pt-1 blink"></i>
        {t("Invitation_InvitationNotFound")} {invitationDetail?.contactMail}
      </>
    );
  };

  const expiredContent = () => {
    return (
      <>
        <div>
          <p>
            <i className="pi pi-exclamation-triangle pr-2 pt-1"></i>
            {t("New_Desktop_IniviteExpirePage", {
              contact: invitationDetail?.contactMail,
            })}
          </p>

          <p>{t("InvLinkExpireAfter")}</p>

          <p>{t("CheckTheSpamBox")}</p>
        </div>
      </>
    );
  };

  const passwordHeader = <h6>{t("Password")}</h6>;

  const confirmPasswordHeader = <h6>{t("ConfirmNewPass")}</h6>;

  const getFormErrorMessage = (name: string) => {
    const temp = errors[name as keyof IInvitation];
    return temp && <Message severity="error" text={temp.message}></Message>;
  };

  return (
    <div className="p-2">
      {show_loader ? (
        <Loading></Loading>
      ) : (
        <div className="login-body">
          <div className="login-wrapper">
            <div className="login-panel">
              <button className="logo p-link">
                <img
                  src={client_info.logo}
                  alt={client_info.name}
                  loading="lazy"
                />
              </button>

              {invitationDetail?.missing && (
                <div>
                  <Message severity="error" content={missingContent}></Message>
                </div>
              )}

              {invitationDetail?.expired && (
                <div>
                  <Message severity="error" content={expiredContent}></Message>
                </div>
              )}

              {!invitationDetail?.missing && !invitationDetail?.expired && (
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  className="p-fluid"
                  autoComplete="password"
                  noValidate
                >
                  <input
                    autoComplete="false"
                    name="hidden"
                    type="text"
                    style={{ display: "none" }}
                  ></input>
                  <h5 className="p-text-center pb-4">{t("SetYourPassword")}</h5>
                  <div className="p-field pb-1">
                    <span >
                      <Controller
                        name="newPassword"
                        control={control}
                        
                        rules={{
                          required: {
                            value: true,
                            message: t("ValidationPasswordRequired"),
                          },
                          minLength: {
                            value: 8,
                            message: t("New_Desktop_CharactersLong", {
                              name: t("Password"),
                              minimum: 8,
                            }),
                          },
                          pattern: {
                            value:
                              /^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,_]).{8,}$/,
                            message: t(
                              "ContainsAtLeastOneNumberAndSpecialCharacter"
                            ),
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <Password
                          
                            id={field.name}
                            {...field}
                            toggleMask
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                            placeholder={t("Password")}
                            minLength={8}
                            header={passwordHeader}
                            autoComplete="new-password"
                            strongRegex="^(?=.*?[A-Z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-.,_]).{8,}$"
                          />
                        )}
                      />
                      {/* <label
                        htmlFor="newPassword"
                        className={classNames({
                          "p-error": errors.newPassword,
                        })}
                      >
                       
                      </label> */}
                    </span>

                    {getFormErrorMessage("newPassword")}
                  </div>
                  <div className="p-field">
                    <span>
                      <Controller
                        name="confirmPassword"
                        control={control}
                        rules={{
                          required: t("ValidationPasswordRequired"),
                          validate: (value: any) => {
                            if (newPassword != value) return t("TheNewPass");
                          },
                        }}
                        render={({ field, fieldState }) => (
                          <Password
                            id={field.name}
                            {...field}
                            toggleMask
                            className={classNames({
                              "p-invalid": fieldState.invalid,
                            })}
                           autoComplete="new-password"
                            feedback={false}
                            header={confirmPasswordHeader}
                            placeholder={t("ConfirmNewPass")}
                          />
                        )}
                      />
                      {/* <label
                        htmlFor="confirmPassword"
                        className={classNames({
                          "p-error": errors.confirmPassword,
                        })}
                      >
                        {t("ConfirmNewPass")}*
                      </label> */}
                    </span>

                    {getFormErrorMessage("confirmPassword")}
                  </div>
                  <div className="pb-4 pt-5 text-justify pl-4 pr-3">
                    <span style={{ color: "#f79530" }}>{"Note"} :</span>{" "}
                    {t("MessagePasswordValidation")}
                  </div>
                  <Button type="submit" label="Submit" className="p-mt-2" />
                </form>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Invitation;
